var map = {
	"./bobutes-paskola.png": 5814,
	"./centro-kredito-unija.png": 5815,
	"./citadele.png": 5816,
	"./first-finance.png": 5817,
	"./germanto-lobis.png": 5818,
	"./hipocredit.png": 5819,
	"./kreditu-centras.png": 5820,
	"./magnus.png": 5821,
	"./manobank.png": 5822,
	"./memelio-taupomoji-kasa.png": 5823,
	"./mogo.png": 5824,
	"./paskola-23.png": 5825,
	"./paskolu-klubas.png": 5826,
	"./placeholder.png": 5827,
	"./rato.png": 5828,
	"./savy.png": 5829,
	"./smspinigai-paskolos-lt.png": 5830,
	"./taupa.png": 5831,
	"./vivus.png": 5832,
	"./westkredit.png": 5833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5813;